import {
  setOrganisation,
  setOrganisations,
  setOrganisationSearchResults,
} from "../state";

const BASE_URL = process.env.REACT_APP_BASE_URL;

// Helper function to get Authorization header
const authHeader = (getState) => ({
  Authorization: `Bearer ${getState().token}`,
  "Content-Type": "application/json",
});

// Fetch a single organisation by ID
export const fetchOrganisation = (id) => async (dispatch, getState) => {
  try {
    const organisationResponse = await fetch(
      `${BASE_URL}/organisations/${id}`,
      {
        method: "GET",
        headers: authHeader(getState),
      }
    );

    if (!organisationResponse.ok)
      throw new Error("Failed to fetch organisation");

    const organisation = await organisationResponse.json();
    dispatch(setOrganisation(organisation));
    return organisation;
  } catch (error) {
    console.error("Error while fetching organisation:", error);
    return { error: error.message };
  }
};

// Fetch all organisations with optional filters
export const fetchOrganisations =
  (filters = {}) =>
  async (dispatch, getState) => {
    try {
      const query = new URLSearchParams(filters).toString();
      const organisationsResponse = await fetch(
        `${BASE_URL}/organisations?${query}`,
        {
          method: "GET",
          headers: authHeader(getState),
        }
      );
      if (!organisationsResponse.ok)
        throw new Error("Failed to fetch organisations");

      const data = await organisationsResponse.json();

      dispatch(
        setOrganisations({ data: data.organisations, total: data.total })
      );
      return data;
    } catch (error) {
      console.error("Error while fetching organisations:", error);
      return { error: error.message };
    }
  };

// Search organisations by name
export const searchOrganisations = (name) => async (dispatch, getState) => {
  try {
    const organisationsResponse = await fetch(
      `${BASE_URL}/organisations/search?name=${name}`,
      {
        method: "GET",
        headers: authHeader(getState),
      }
    );
    if (!organisationsResponse.ok)
      throw new Error("Failed to search organisations");

    const organisations = await organisationsResponse.json();
    dispatch(setOrganisationSearchResults(organisations));
    return organisations;
  } catch (error) {
    console.error("Error while searching organisations:", error);
    return { error: error.message };
  }
};

// Create a new organisation
export const createOrganisation = (values) => async (dispatch, getState) => {
  try {
    const organisationResponse = await fetch(`${BASE_URL}/organisations`, {
      method: "POST",
      headers: authHeader(getState),
      body: JSON.stringify(values),
    });
    if (!organisationResponse.ok)
      throw new Error("Failed to create organisation");

    const organisation = await organisationResponse.json();
    dispatch(setOrganisation(organisation));
    dispatch(fetchOrganisations());
    return organisation;
  } catch (error) {
    console.error("Error while creating organisation:", error);
    return { error: error.message };
  }
};

// Update an organisation by ID
export const updateOrganisation =
  (id, values) => async (dispatch, getState) => {
    try {
      const organisationResponse = await fetch(
        `${BASE_URL}/organisations/${id}`,
        {
          method: "PATCH",
          headers: authHeader(getState),
          body: JSON.stringify(values),
        }
      );
      if (!organisationResponse.ok)
        throw new Error("Failed to update organisation");

      const organisation = await organisationResponse.json();
      dispatch(setOrganisation(organisation));
      dispatch(fetchOrganisations());
      return organisation;
    } catch (error) {
      console.error("Error while updating organisation:", error);
      return { error: error.message };
    }
  };

// Delete an organisation by ID
export const deleteOrganisation = (id) => async (dispatch, getState) => {
  try {
    const response = await fetch(`${BASE_URL}/organisations/${id}`, {
      method: "DELETE",
      headers: authHeader(getState),
    });
    if (!response.ok) throw new Error("Failed to delete organisation");

    const organisations = getState().organisations.filter(
      (organisation) => organisation._id !== id
    );
    dispatch(setOrganisations(organisations));
    return id;
  } catch (error) {
    console.error("Error while deleting organisation:", error);
    return { error: error.message };
  }
};
